module.exports = __webpack_public_path__ + "img/pensive-face.31bdc65f.png";